import React from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import FlatPagination from 'material-ui-flat-pagination';
import { withAlert } from 'react-alert';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { connect } from 'react-redux';
import Dropdown from 'react-dropdown';
import * as _ from 'lodash';
import * as moment from 'moment';
import loader from '../../../images/Spin-1s-107px.gif';
import {
  getAllSettlement,
  getEnrolledListByAffiliateId,
  getAllFilteredSettlement,
  getAllReferredUserByAffiliateId,
  requestDismissSettlement,
} from '../../../Actions/actions';
import SearchText from '../../common/searchtext';

import BannerHead from '../../BannerHead';


const WAIT_INTERVAL = 1000;
const ENTER_KEY = 13;

class EnrollementListComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      b: [],
      offset: 0,
      total: '',
      searcht: '',
      sort: 0,
      size: 10,
      errors: {},
      isLoader: true,
      recursive: false,
      userid: localStorage.getItem('userId'),
    };
    this.onChange = this.onChange.bind(this);
    this.categorySelect = this.categorySelect.bind(this);
    this.sortSelect = this.sortSelect.bind(this);
    this.sizeSelect = this.sizeSelect.bind(this);
    this.getStateData = this.getStateData.bind(this);
    this.TheLayerUpAnswerstoQuestions = this.TheLayerUpAnswerstoQuestions.bind(
      this,
    );
  }

  componentWillMount() {
    const id = this.props.settlementIdE;
    if (id !== undefined) {
      this.setState({ sort: id });
    }
  }

  /**
   * Post answers to a questions
   * @param {*} data
   */
  TheLayerUpAnswerstoQuestions(data) {
    this.props.answerToQuestionAction(data);
  }

  /**
   * Get Enrolled List by Affiliate Id
   * @param {} e
   */
  onChange() {
    const { size } = this.state;
    this.setState({ isLoader: true, offset: 0 });
    this.props.getEnrolledListByAffiliateId({
      pageNumber: 0,
      pageSize: size,
      searchKeyword: this.state.searcht,
      settlementId: 0,
      userId: this.state.userid,
    });
  }

  timer = null;

  /**
   * Search Filter on change text in search bar
   */
  handleChange = (e) => {
    clearTimeout(this.timer);
    this.setState({ searcht: e.target.value });
    this.timer = setTimeout(this.triggerChange, WAIT_INTERVAL);
  };

  componentDidMount() {
    if (this.props.settlementIdE !== undefined) {
      this.setState({
        sort: Number.parseInt(this.props.settlementIdE, 10),
      });
    }
  }

  handleKeyDown = (e) => {
    if (e.keyCode === ENTER_KEY) {
      clearTimeout(this.timer);
      this.triggerChange();
    }
  };

  triggerChange = (e) => {
    this.onChange(e);
  };

  /**
   * Select Category List
   * @param {*} e
   */
  categorySelect(e) {
    const { size } = this.state;

    this.setState({ isLoader: true });
    // this.setState({ category: e.value });
    this.setState({ offset: 0 });
    const result = {
      catgoryId: e.value,
      pageNumber: 0,
      pageSize: size,
      searchKeyword: this.state.searcht,
      sortBy: this.state.sort,
      userId: this.state.userid,
    };
    this.props.getEnrolledListByAffiliateId(result);
  }

  /**
   * Sort Enrolled List
   * @param {*} e
   */
  sortSelect(e) {
    this.setState({ isLoader: true, sort: e.value, offset: 0 });
    const { searcht, userid, size } = this.state;
    const result = {
      pageNumber: 0,
      pageSize: size,
      searchKeyword: searcht,
      settlementId: e.value,
      userId: userid,
    };
    this.props.getEnrolledListByAffiliateId(result);
  }

  /**
   * Size Enrolled List
   * @param {*} e
   */
  sizeSelect(e) {
    this.setState({ isLoader: true, size: e.value, offset: 0 });
    const { searcht, userid, sort } = this.state;
    const result = {
      pageNumber: 0,
      pageSize: e.value,
      searchKeyword: searcht,
      settlementId: sort,
      userId: userid,
    };
    this.props.getEnrolledListByAffiliateId(result);
  }

  handleClick(offset) {
    this.setState({ isLoader: true, offset });
    const { searcht, userid, size } = this.state;
    const pageNumber = offset / size;
    this.props.getEnrolledListByAffiliateId({
      pageNumber,
      pageSize: size,
      searchKeyword: searcht,
      userId: userid,
      settlementId: 0,
    });
  }
  // componentDidUpdate()
  // {
  //   const {phase} = this.props.data;
  //   if()
  // }

  componentWillReceiveProps(nextProps) {
    const { size } = this.state;
    const allSettlementDatawe = nextProps.allSettlementDatawe
      ? nextProps.allSettlementDatawe
      : {};
    this.setState({ b: allSettlementDatawe });
    // const allSettlementDataweHtml = [];

    if (allSettlementDatawe !== 'undefined') {
      this.setState({ total: allSettlementDatawe !== undefined ? allSettlementDatawe.result !== undefined ? allSettlementDatawe.result.totalCount : 0 : 0 });
    }

    const confrimSettlement = nextProps.data.receiveDismissSettlement;

    if (typeof confrimSettlement !== 'undefined') {
      if (confrimSettlement.code === 200) {
        const offset = this.state.offset;
        const pageNumber = offset / size;
        if (this.state.recursive === true) {
          this.props.getAllReferredUserByAffiliateId({
            pageNumber,
            pageSize: size,
            searchKeyword: '',
            catgoryId: '',
            sortBy: '',
            userId: this.state.userid,
          });
          this.setState({ recursive: false });
        }
      }
    }
    this.setState({
      isLoader: false,
    });
  }

  getStateData() {
    this.setState({ recursive: true });
  }

  render() {
    const {
      searcht,
      errors,
      sort,
      size,
      b,
      isLoader,
    } = this.state;
    const { settlementDataAffiliate, phase } = this.props.data;
    const sortArray = [{
      value: 0,
      label: 'Settlements Name',
      name: 'Settlements Name',
    }];
    if (settlementDataAffiliate.result !== undefined) {
      if (settlementDataAffiliate.result.totalSettlementForDropdown !== undefined) {
        settlementDataAffiliate.result.totalSettlementForDropdown.map(item => sortArray.push({
          value: item.settlementId,
          label: item.shortName,
          name: item.shortName,
        }));
      }
    }

    const cSelectedSort = _.find(sortArray, { value: sort });
    const cDefaultSort = cSelectedSort;

    const sizeArray = [];
    sizeArray.push({ value: 10, label: ' 10 at a time', name: '10 at a time' });
    sizeArray.push({ value: 25, label: ' 25 at a time', name: '25 at a time' });
    sizeArray.push({ value: 50, label: '50 at a time', name: '50 at a time' });
    sizeArray.push({
      value: 100,
      label: '100 at a time',
      name: '100 at a time',
    });
    sizeArray.push({
      value: 500,
      label: '500 at a time',
      name: '500 at a time',
    });
    const cSelectedSize = _.find(sizeArray, { value: size });
    const cDefaultSize = cSelectedSize;

    const allSettlementDataweHtml = [];
    if (b.records !== 'undefined') {
      if (Object.keys(b).length > 0 && b.code !== 400) {
        if (b.result !== undefined) {
          b.result.records.map((item, index) => {
            allSettlementDataweHtml.push(
            // <TableBody>

              <TableRow key={`s${index}`}>
                <TableCell>
                  <div>
                    <p>
                      <b>
                        {item.dtoUser.firstName}
                        {' '}
                        {item.dtoUser.lastName}

                      </b>
                    </p>
                    <p>
                      {' '}
                      {item.dtoUser.roleName}
                    </p>
                  </div>
                </TableCell>
                <TableCell>
                  <p>
                    {item.dtoUser.roleName === 'Consumer' ? item.dtoUser.employer : item.dtoUser.companyName}
                    {' '}
                  </p>

                </TableCell>
                <TableCell>
                  <div className="row">
                    <div className="col s2 right-align">
                      <span>
                        <i className="material-icons">phone</i>

                      </span>
                    </div>
                    <div className="col s10">
                      {' '}
                      {item.dtoUser.mobilePhone}
                    </div>
                  </div>
                  <div>
                    <div className="col s2 right-align">
                      <span>
                        <i className="material-icons">email</i>

                      </span>
                    </div>
                    <div className="col s10">
                      {' '}
                      {item.dtoUser.email}
                    </div>
                  </div>
                </TableCell>
                <TableCell>
                  <p>{item.name}</p>
                </TableCell>

                <TableCell>
                  <p>
                    {' '}
                    {item.enrollementStatus !== undefined ? item.enrollementStatus : 'Started'}
                    {' '}
                  </p>
                  <p>
                    {' '}
                    {moment(item.enrollmentDate !== undefined ? item.enrollmentDate : '').format('MM-DD-YYYY') !== 'Invalid date' ? moment(item.enrollmentDate !== undefined ? item.enrollmentDate : '').format('MM-DD-YYYY') : 'TBA' }
                  </p>
                </TableCell>
                <TableCell>
                  <p>{item.statusName}</p>
                </TableCell>
              </TableRow>,
            );
            return true;
          });
        } else {
          allSettlementDataweHtml.push(
            <TableRow key="1">
              <TableCell colspan="6">
                {b.collectMessage.messageShort !== undefined ? b.collectMessage.messageShort : '' }
              </TableCell>
            </TableRow>,
          );
        }
      }
    }
    let loader1;
    if (isLoader || phase === 'loading') {
      loader1 = (
        <div className="loader">
          <img src={loader} alt="" />
        </div>
      );
    }
    return (
      <span>
        {loader1}
        <div className="section-content dashboard">
          <div className="row">
            <div className="dashboard-tabs">
              <div className="row ">
                {/* <div className="dashboard-bg settlement-dashboardbg">
                  <div className="col s12">
                    <h3> */}
                      {/* { this.state.total} */}
                      {' '}
                      <BannerHead title="Enrollments" />


                    {/* </h3>
                  </div>
                  <div className="col s8 offset-s1">
                    <ul className="tabs">
                      <li className="indicator" />
                    </ul>
                  </div>
                </div> */}
                <div className="settlemnt-search">
                  <div className="col s12 m4">
                    <div className="search">
                      <div className="input-field ">
                        <SearchText
                          id="icon_prefix"
                          field="searcht"
                          placeholder="Search"
                          value={searcht}
                          error={errors.searcht}
                          onChange={this.handleChange}
                          onKeyDown={this.handleKeyDown}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col s12 m4 settlement-dd">
                    <div className="display-dropdown">
                      <Dropdown
                        name="sort "
                        className="browser-default"
                        options={sizeArray}
                        onChange={this.sizeSelect}
                        value={cDefaultSize}
                        placeholder="Select an option"
                      />
                    </div>
                  </div>
                  <div className="col s12 m4 settlement-dd">
                    <div className="display-dropdown">
                      <Dropdown
                        name="sort "
                        className="browser-default"
                        options={sortArray}
                        onChange={this.sortSelect}
                        value={cDefaultSort}
                        placeholder="Select an option"
                      />
                    </div>
                  </div>
                </div>

                <div
                  id="AllSettlemnet"
                  className="referral-data col s12 tab-data active allstatement-data"
                >
                  <div className="col s12">
                    <div className="settlement-grid">
                      <div className="settlement-grid-inner">
                        <div className="grid-outer div-full">
                          {allSettlementDataweHtml.length > 0 ? (
                            <div className="partner-table">
                              <Table className="table-layout">
                                <TableHead>
                                  <TableRow>
                                    <TableCell className="table-name">
                                      Name
                                    </TableCell>
                                    <TableCell className="table-company-name">
                                      Company Name
                                    </TableCell>
                                    <TableCell className="table-contact">
                                      Contact
                                    </TableCell>
                                    <TableCell className="table-settlement">
                                      Settlement
                                    </TableCell>
                                    <TableCell className="table-enroll">
                                      Enrolled On
                                    </TableCell>
                                    <TableCell className="table-status">
                                      Status
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {allSettlementDataweHtml}
                                </TableBody>
                              </Table>

                              <MuiThemeProvider>
                                <FlatPagination
                                  offset={this.state.offset}
                                  limit={size}
                                  total={this.state.total}
                                  onClick={(e, offset) =>
                                    this.handleClick(offset)
                                  }
                                />
                              </MuiThemeProvider>
                            </div>
                          ) : (
                            '')}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </span>
    );
  }
}

EnrollementListComponent.contextTypes = {
  router: PropTypes.object.isRequired,
};

/**
 * Get data to reducer
 * @param {*} state
 */
const mapStateToProps = state => ({ data: state.data });

/**
 * Set data to reducer
 * @param {*} dispatch
 */
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getAllSettlement,
      getEnrolledListByAffiliateId,
      getAllFilteredSettlement,
      getAllReferredUserByAffiliateId,
      requestDismissSettlement,
    },
    dispatch,
  );

export default withAlert(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(EnrollementListComponent),
);
